// extracted by mini-css-extract-plugin
module.exports = {"container":"ReviewLink_container__2194Q"};